<template>
  <SectionWithAnchor :anchorId="AnchorLinks.HowItWorks" class="row">
    <div :class="['col-md-10 col-lg-8', $style.container]">
      <HowItWorksSection />
    </div>
  </SectionWithAnchor>
</template>

<script setup lang="ts">
import HowItWorksSection from '@/components/common/HowItWorksSection/HowItWorksSection.vue';
import SectionWithAnchor from '@/components/common/SectionWithAnchor/SectionWithAnchor.vue';
import { AnchorLinks } from '@/types';
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.container {
  @include grid-media-query(sm) {
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
